import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
const NAMES = ['Sofía', 'Camila', 'Martina', 'Valentina', 'Lucía', 'Julieta', 'Micaela', 'Florencia', 'Agustina', 'Catalina'];
const CITIES = ['Rosario', 'Córdoba', 'La Plata', 'Mendoza', 'Buenos Aires', 'Mar del Plata', 'Tucumán', 'Salta', 'Santa Fe', 'Neuquén'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setCurrentBuyer({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay before first popup
    const initialTimeout = setTimeout(showPopup, 10000);
    // Then show randomly every 15-30 seconds
    const interval = setInterval(() => {
      if (!isVisible) {
        showPopup();
      }
    }, Math.random() * 15000 + 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-25">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:w-80 bg-zinc-900 border border-zinc-800 rounded-xl p-4 shadow-2xl z-50 flex items-start gap-3" data-id="element-26">
          <div className="mt-0.5 flex-shrink-0" data-id="element-27">
            <CheckCircle2 className="text-pink-500 w-5 h-5" data-id="element-28" />
          </div>
          <div className="flex-1" data-id="element-29">
            <p className="text-sm text-zinc-300" data-id="element-30">
              <span className="font-semibold text-white" data-id="element-31">
                {currentBuyer.name}
              </span>{' '}
              de {currentBuyer.city} acaba de comprar este libro digital.
            </p>
            <p className="text-xs text-zinc-500 mt-1" data-id="element-32">Hace unos minutos</p>
          </div>
          <button onClick={() => setIsVisible(false)} className="text-zinc-500 hover:text-zinc-300 transition-colors" data-id="element-33">
            <X className="w-4 h-4" data-id="element-34" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}